import { render } from "./404-View.vue?vue&type=template&id=e4f8fe34&scoped=true"
const script = {}

import "./404-View.vue?vue&type=style&index=0&id=e4f8fe34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e4f8fe34"

export default script